import type { KonjugationPayload } from '@/core/types';

import type { AppDefinition } from '../types';
import { CardBack } from './CardBack';
import { CardFront } from './CardFront';
import { MissRow } from './MissRow';

/**
 * Konjugation — produce the whole verb.
 *
 * The other half of the split `verbs` announced and deliberately did not take:
 * Verbs asks what `anfangen` means, this one asks for `fange an`, `fängst an`,
 * `fing an`, `hat angefangen`. Same lemma, same seed file, separate decks and
 * separate progress — the split that already exists between Nouns and
 * Der·Die·Das, one level down.
 *
 * One card is one verb, not one tense. Six persons in the Präsens plus the two
 * principal parts, eight fields, each graded as you leave it and answered until
 * right. A tense-per-card deck was the obvious first shape and was wrong: the
 * six-line Perfekt it implies is the same participle six times over an
 * auxiliary that is already its own card, so the whole tense collapses into the
 * single field it actually teaches.
 *
 * Not here, on purpose: reflexive verbs, which conjugate their pronoun too, and
 * every level above A1 until its principal parts are filled in the way A1's
 * were.
 */
export const konjugationApp: AppDefinition<KonjugationPayload> = {
  id: 'konjugation',
  display_name: 'Konjugation',
  CardFront,
  CardBack,
  MissRow,
};
